module.exports = __webpack_public_path__ + "img/away.fb21029d.png";